export default {
  "nav.spreadsheet": "Tableur",
  "nav.products": "Produits",
  "nav.sellers": "Vendeurs",
  "nav.reviews": "Avis",
  "nav.shipping": "Livraison",
  "nav.guides": "Guides",
  "nav.safety": "Sécurité",
  "nav.home": "Accueil",
  "nav.shoppingGuide": "Guide d'achat",
  "nav.categories": "Catégories",
  "nav.cta": "Visiter le site principal",

  "hero.badge": "Ressource d'achat indépendante",
  "hero.title": "AllChinaBuy Spreadsheet — Produits, vendeurs et guides d'achat",
  "hero.subtitle":
    "Explorez des tableurs AllChinaBuy organisés, des trouvailles produits, des ressources vendeurs, des guides QC, des informations de livraison, des avis et des tutoriels pratiques — le tout au même endroit.",
  "hero.searchPlaceholder": "Rechercher des produits, vendeurs, catégories ou guides AllChinaBuy…",
  "hero.ctaPrimary": "allchinabuy spreadsheet",
  "hero.ctaSecondary": "acheter maintenant",
  "hero.trust": "Ressource d'achat indépendante • Contenu mis à jour • Guides pratiques • Recherche axée sur la sécurité",

  "categories.label": "Parcourir par catégorie",
  "categories.title": "Trouvez plus vite ce qu'il vous faut",
  "categories.subtitle":
    "Accédez directement à la section du magasin principal dont vous avez besoin — chaque catégorie ci-dessous ouvre la liste de produits correspondante.",

  "featured.title": "Votre ressource complète AllChinaBuy Spreadsheet",
  "featured.subtitle":
    "Faites vos recherches d'abord, puis continuez vers le site principal quand vous êtes prêt. Ces guides couvrent les sujets les plus demandés par les acheteurs.",
  "featured.spreadsheet.title": "AllChinaBuy Spreadsheet",
  "featured.spreadsheet.desc":
    "Parcourez des ressources produits organisées et les catégories populaires.",
  "featured.review.title": "Avis AllChinaBuy",
  "featured.review.desc":
    "Comprenez la plateforme, ses coûts, ses fonctionnalités, ses forces et ses limites.",
  "featured.shipping.title": "Frais de livraison AllChinaBuy",
  "featured.shipping.desc":
    "Apprenez comment le poids, les dimensions, la destination et les lignes d'envoi influent sur les coûts.",
  "featured.qc.title": "Contrôle qualité AllChinaBuy",
  "featured.qc.desc":
    "Comprenez les photos QC, l'inspection et les vérifications avant expédition.",
  "featured.warehouse.title": "Entrepôt AllChinaBuy",
  "featured.warehouse.desc":
    "Découvrez le stockage, l'inspection et la consolidation en entrepôt.",
  "featured.safety.title": "Sécurité AllChinaBuy",
  "featured.safety.desc":
    "Apprenez à repérer les faux sites, le phishing et les vendeurs à risque.",

  "searches.title": "Recherches populaires",
  "searches.subtitle": "Les questions et sujets les plus consultés par les lecteurs.",
  "searches.item1": "Avis AllChinaBuy",
  "searches.item2": "Frais de livraison AllChinaBuy",
  "searches.item3": "Coupon AllChinaBuy",
  "searches.item4": "Code promo AllChinaBuy",
  "searches.item5": "Entrepôt AllChinaBuy",
  "searches.item6": "AllChinaBuy fiable",

  "why.title": "Pourquoi utiliser cette ressource",
  "why.subtitle": "Conçue pour rendre l'achat en Chine plus clair, plus sûr et plus facile à comparer.",
  "why.point1.title": "Catégories organisées",
  "why.point1.desc": "Chaque type de produit est regroupé pour trouver rapidement une fourchette de prix réaliste.",
  "why.point2.title": "Guides originaux",
  "why.point2.desc": "Des explications simples écrites pour de vrais acheteurs, pas du contenu recyclé.",
  "why.point3.title": "La sécurité avant tout",
  "why.point3.desc": "Des conseils pratiques pour repérer faux sites, phishing et vendeurs à risque.",
  "why.point4.title": "Directement au magasin",
  "why.point4.desc": "Des liens sortants clairs vers la section exacte dont vous avez besoin, quand vous êtes prêt.",

  "articles.title": "Derniers articles",
  "articles.subtitle": "Des guides originaux et approfondis sur le tableur AllChinaBuy.",
  "articles.readMore": "Lire le guide",
  "articles.cardTitle": "AllChinaBuy Spreadsheet : le guide complet 2026",
  "articles.cardDesc":
    "Produits, vendeurs, photos QC et livraison — comment organiser chaque commande dans un tableau clair et triable.",

  "faq.title": "Questions fréquentes",
  "faq.subtitle": "Des réponses rapides aux questions les plus posées par les acheteurs.",
  "faq.q1": "Qu'est-ce qu'un tableur AllChinaBuy ?",
  "faq.a1":
    "C'est un tableau de suivi auto-organisé pour les commandes passées via une plateforme d'achat en Chine — listant produits, vendeurs, prix, statut QC et détails de livraison dans une vue triable.",
  "faq.q2": "Est-ce le site officiel d'AllChinaBuy ?",
  "faq.a2":
    "Non. C'est une ressource informative indépendante, sans affiliation officielle. Pour les informations officielles, vérifiez toujours directement la plateforme actuelle.",
  "faq.q3": "Ai-je besoin d'un tableur pour les petites commandes ?",
  "faq.a3":
    "Pas obligatoirement, mais un tableau simple aide à comparer le coût total entre vendeurs et à garder les notes QC et de poids au même endroit.",
  "faq.q4": "Quelles catégories puis-je parcourir ici ?",
  "faq.a4":
    "Chaussures, hoodies, t-shirts, vestes, pantalons, couvre-chefs, ensembles, sous-vêtements, maillots, accessoires, sacs, ceintures, parfums et plus — chacun lié à la section correspondante du magasin principal.",

  "cta.title": "Prêt à explorer davantage ?",
  "cta.text":
    "Utilisez nos guides pour faire vos recherches d'abord, puis continuez vers le site principal quand vous êtes prêt.",
  "cta.button": "Aller au site principal",

  "footer.tagline": "La ressource complète produits, vendeurs, QC et achat",
  "footer.disclaimer":
    "Ce site est un site d'information indépendant et n'est pas affilié à AllChinaBuy ni approuvé par lui. Les prix, la livraison et les politiques évoluent — vérifiez toujours la plateforme officielle actuelle.",
  "footer.resourcesTitle": "Ressources",
  "footer.legalTitle": "Mentions légales",
  "footer.languagesTitle": "Langues",
  "footer.about": "À propos",
  "footer.editorial": "Politique éditoriale",
  "footer.safety": "Centre de sécurité",
  "footer.disclaimerLink": "Avertissement",
  "footer.privacy": "Politique de confidentialité",
  "footer.terms": "Conditions",
  "footer.contact": "Contact",
  "footer.sitemap": "Plan du site",
  "footer.mainSite": "Site principal",
  "footer.rights": "Tous droits réservés.",

  "category.shoes": "Chaussures",
  "category.hoodies": "Hoodies / Sweats",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Vestes",
  "category.pants": "Pantalons / Shorts",
  "category.headwear": "Couvre-chefs",
  "category.sets": "Ensembles",
  "category.underwear": "Sous-vêtements",
  "category.jersey": "Maillots",
  "category.accessories": "Accessoires",
  "category.bags": "Sacs",
  "category.belts": "Ceintures",
  "category.perfumes": "Parfums",
  "category.other": "Autres articles",

  "article.notFound": "Article introuvable",
  "article.summary": "Résumé",
  "article.backHint": "Revenez à l'accueil pour parcourir toutes les catégories et guides.",

  "category.guide": "Guide",
  "category.review": "Avis",
  "category.safety": "Sécurité",
  "category.shipping": "Livraison",
  "category.warehouse": "Entrepôt",
  "category.qc": "Contrôle qualité",
  "category.coupons": "Coupons",
  "category.comparison": "Comparaison",
  "category.beginners": "Débutants",
};